/**
 * La regla de cambio de cliente del mockup (`switchClient()`), como función pura:
 *
 *  - SIN modal: se cierra el informe (los informes son por cliente — muere el bug de la vista
 *    ajena que quedaba abierta con "MODIFICADA");
 *  - se MANTIENEN la plantilla, el período, la comparación y los filtros;
 *  - sólo cuentas/líneas se restablecen a "Incluir todas" (y el modo vuelve a cuentas);
 *  - `accountsResetAt` dispara el flash rojo (~8 s) y la pill "Cuentas restablecidas" (12 s).
 *
 * Devuelve también si había cambios sin guardar, para que el toast lo diga.
 */
import {canonicalizeInforme, hasUnsavedWork, isInformeDirty} from './canonical';

export const ACCOUNTS_FLASH_MS = 8000;
export const ACCOUNTS_PILL_MS = 12000;

export function applyClientChange(state, newClientId, now = Date.now()) {
    const discardedChanges = !!state.informe && isInformeDirty(state);
    // ¿Había trabajo del usuario ANTES del switch? Importa porque la plantilla se CONSERVA (regla de
    // producto, `template: state.template` abajo): ese trabajo sigue vivo en pantalla después de
    // cambiar de cliente, así que el guard tiene que seguir cubriéndolo.
    const hadWork = hasUnsavedWork(state);
    const prevBaseline = state.baseline || {};
    const next = {
        ...state,
        agencyClientId: newClientId,
        informe: null,
        settings: {
            ...state.settings,
            source_type: 'AD_ACCOUNTS',
            selected_items: [],
        },
        template: state.template,
        baseline: {informe: null, template: prevBaseline.template || null},
        accountsResetAt: now,
    };
    return {
        state: {
            ...next,
            baseline: {
                ...next.baseline,
                // SIN trabajo previo, el switch es un punto de partida nuevo y no hay nada que
                // perder: se estampa el baseline sobre el estado ya cambiado y abrir un informe
                // enseguida no pregunta de gusto (card eo7J0qds).
                //
                // CON trabajo previo se conserva el baseline VIEJO. Estampar uno nuevo acá lo
                // igualaba al contenido vivo y apagaba el guard sobre paneles que seguían en
                // pantalla: desde ahí, abrir otro informe o un F5 se los comía en silencio, y ni
                // siquiera salía el toast de descarte (review C-informes-02).
                informe: hadWork ? (prevBaseline.informe || null) : canonicalizeInforme(next),
            },
        },
        discardedChanges,
    };
}
